module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/step3-full-fc08f8d15c3031bb1eba04502a1121af.jpg";